import c from "./memoize.js";
var i = 500;
function m(a) {
  var e = c(a, function(t) {
    return r.size === i && r.clear(), t;
  }), r = e.cache;
  return e;
}
export {
  m as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_memoizeCapped.js
// module id = 1495
// module chunks = 41